/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ptc.pm.collaborators.title': '您的共同作業者',
  'ptc.pm.error-heading': '發生錯誤',
  'ptc.pm.error-image-alt-text': '機器人故障，多位人員正在修復此問題。',
  'ptc.pm.error-text': '我們會持續追蹤這些錯誤，如果重新整理之後仍無法修復，您可以隨時與我們聯繫',
  'ptc.pm.num-members': '{memberCount, plural, other {{memberCount,number} 位成員}}',
  'ptc.pm.people': '人員',
  'ptc.pm.teams': '團隊',
  'ptc.pm.view-your-profile': '檢視您的設定檔',
  'ptc.pm.your-teams.title': '您的團隊',
};
